import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  max-width: 1300px;
  margin: 2% auto;
  padding: 1rem;

  .title {
    font-size: 1.5rem;
    line-height: 1.8125rem;
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  }

  .sliderStyle {
    margin: 0.1rem;
  }

  @media only screen and (min-width: 800px) {
    padding-left: 6rem !important;
  }
`

export const ButtonWrapper = styled.div`
  width: 10%;
  margin: 1rem 0 1rem auto;
  display: flex;
  justify-content: space-between;

  button {
    background: none;
    border: none;
  }

  @media only screen and (max-width: 600px) {
    display: none;
  }
`
